// src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAuNd3vNTkpJRpuA9hhjayBc8saPF3NELg",
  authDomain: "telviora.firebaseapp.com",
  projectId: "telviora",
  storageBucket: "telviora.firebasestorage.app",
  messagingSenderId: "29352034489",
  appId: "1:29352034489:web:0bc7993416858a05919b68",
  measurementId: "G-JBE8DVDPJF",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
// googleProvider.setCustomParameters({
//   client_id: '66686595865-uqkup2rok47dmn9h8jmmu0a4cth6hq83.apps.googleusercontent.com'
// });
export const appleProvider = new OAuthProvider("apple.com");
export default app;
